import { CreateQuestions } from "../../quiz-zone/create-questions";

const CreateExamQuestion = () => (
	<CreateQuestions type="exam" title={"Exam"} subTitle="Exam" />
);

export default CreateExamQuestion;
